module.exports = __webpack_public_path__ + "img/jiaoda.d22c556a.jpg";